import React from "react";
import {
  Create,
  TextInput,
  SimpleForm,
  useNotify,
  useRefresh,
  useRedirect,
  required,
} from "react-admin";

import { useCreateStyles } from "../__common/MyStyles";
import { MyCreateActions } from "../__common/MyCreateActions";
import { sleep } from "../../common/js/Functions";

export const CultureMediaCreate = (props) => {
  const classes = useCreateStyles();

  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  const onSuccess = () => {
    notify(`Culture medium created`);
    sleep(2000).then(() => {
      redirect("/culture_media");
      refresh();
    });
  };

  return (
    <Create
      title="Create Medium"
      undoable={false}
      onSuccess={onSuccess}
      submitOnEnter={true}
      actions={<MyCreateActions />}
      classes={classes}
      {...props}
    >
      <SimpleForm>
        <TextInput source="code" validate={required()} />
        <TextInput source="culture_medium" validate={required()} />
      </SimpleForm>
    </Create>
  );
};
